import React, {useState} from 'react';

import {FlatButton} from '@pb/kit-component-button';
import Group from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';
import Typography from '@pb/kit-component-typography';

import {collapsibleStepsList, docLink, expandButton, instructionsList, instructionsSection} from '../download-sp-metadata.module.styl';
import {SP_CONFIG_INSTRUCTIONS} from '../utils/sp-config-instructions-data';

import type {CollapsibleInstructionStep} from '../utils/sp-config-instructions-data';

type SpConfigInstructionsProps = {
    providerId: string | null,
    tabKey: 'manual' | 'file',
};

const TAB_INSTRUCTION_KEY: Record<string, 'manualInstructions' | 'fileInstructions'> = {
    manual: 'manualInstructions',
    file: 'fileInstructions',
};

const CollapsibleStepContent: React.FC<{step: CollapsibleInstructionStep}> = ({step}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <>
            {step.text}
            <FlatButton variant="primary" className={expandButton} onClick={() => setIsExpanded(!isExpanded)}>
                {step.linkText}
            </FlatButton>
            {step.textAfter}
            {isExpanded
                ? (
                        <ol className={collapsibleStepsList}>
                            {step.collapsibleSteps.map((subStep, i) => (
                                <li key={i}>{subStep}</li>
                            ))}
                        </ol>
                    )
                : null}
        </>
    );
};

export const SpConfigInstructions: React.FC<SpConfigInstructionsProps> = ({providerId, tabKey}) => {

    const provider = SP_CONFIG_INSTRUCTIONS[providerId ?? 'other'] ?? SP_CONFIG_INSTRUCTIONS.other;
    const steps = provider[TAB_INSTRUCTION_KEY[tabKey]];

    return (
        <div className={instructionsSection}>
            <Typography variant="body-level-1" style={{fontWeight: 600}}>
                How to configure your Identity Provider
            </Typography>
            <Group direction="v" gap="s" style={{paddingTop: 12}}>
                <ol className={instructionsList}>
                    {steps.map((step, index) => (
                        <li key={index}>
                            {typeof step === 'string'
                                ? step
                                : <CollapsibleStepContent step={step}/>}
                        </li>
                    ))}
                </ol>
                {provider.docUrl ? (
                    <a
                        href={provider.docUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={docLink}>
                        {provider.docLabel}
                        <Icon type={Icons.EXTERNAL_LINK} size="Size_12"/>
                    </a>
                ) : null}
                {provider.pdfGuide ? (
                    <a
                        href={provider.pdfGuide.url}
                        download={true}
                        className={docLink}>
                        {provider.pdfGuide.label}
                        <Icon type={Icons.DOWNLOAD} size="Size_12"/>
                    </a>
                ) : null}
            </Group>
        </div>
    );
};
